//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

/** Universal supply shipment status for triggering move document creation. */
export enum SupplyShipmentStatus {
  Created = 0,
  InTransit = 1,
  Accepted = 2,
  PartiallyAccepted = 3
}
